import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Select from "react-select";
import { Translate } from "../../../../Enums/Tranlate";
import { useLocation, useNavigate } from "react-router-dom";
import ProductsService from "../../../../../services/ProductsService";
import CategoryService from "../../../../../services/CategoryService";
import BaseService from "../../../../../services/BaseService";
import PhoneInput from "react-phone-input-2";

const AddProduct = () => {
	const location = useLocation();
	const [formData, setFormData] = useState({
		name_en: "",
		name_ar: "",
		whatsapp_number: "",
		description_en: "",
		description_ar: "",
		image: "",
		status: true,
		price: "",
		type: "new",
		category: "",
	});
	const navigate = useNavigate();
	const [categoriesOptions, setCategoriesOptions] = useState([]);
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth.lang);
	const productsService = new ProductsService();
	const categoryService = new CategoryService();

	useEffect(() => {
		categoryService.getList({ status: true }).then((res) => {
			if (res?.status === 200) {
				let data = res?.data?.data?.data?.map((info) => {
					return {
						label: lang === "en" ? info?.name_en : info?.name_ar,
						value: info?.id,
					};
				});
				setCategoriesOptions(data);
			}
		});
	}, [lang]);

	useEffect(() => {
		if (!location?.state) {
			setIsAdd(true);
		} else {
			setIsAdd(false);
			let state = location?.state;
			setFormData({
				id: state?.id,
				name_en: state?.name_en,
				name_ar: state?.name_ar,
				description_en: state?.description_en,
				description_ar: state?.description_ar,
				image: state?.image,
				whatsapp_number: state?.whatsapp_number,
				status: state?.status,
				price: state?.price,
				type: state?.type,
				category: {
					label:
						lang === "en" ? state?.category?.name_en : state?.category?.name_ar,
					value: state?.gcategory_id,
				},
			});
		}
	}, []);

	const submit = (e) => {
		e.preventDefault();
		if (!formData?.category || !formData?.whatsapp_number) {
			return;
		}
		let data = {
			name_en: formData?.name_en,
			name_ar: formData?.name_ar,
			description_en: formData?.description_en,
			description_ar: formData?.description_ar,
			whatsapp_number: formData?.whatsapp_number,
			image: formData?.image,
			status: formData?.status,
			price: Number(formData?.price),
			type: formData?.type,
			category_id: formData?.category?.value,
		};

		setLoading(true);
		if (isAdd) {
			productsService
				.create(data)
				?.then((res) => {
					if (res?.status === 201) {
						toast.success(res?.data?.message);
						navigate("/products");
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			productsService
				.update(formData?.id, data)
				?.then((res) => {
					if (res?.status === 200) {
						toast.success(res?.data?.message);
						navigate("/products");
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	const fileHandler = (e) => {
		let filesAll = e.target.files;
		const filesData = Object.values(filesAll);

		if (!filesData?.length) {
			return;
		}
		new BaseService().postUpload(filesData[0]).then((res) => {
			if (res?.data?.status) {
				setFormData((prev) => ({ ...prev, image: res.data.url }));
			}
		});
	};

	return (
		<div>
			<div
				className="d-flex align-items-center"
				style={{ gap: "8px", margin: "12px 0 32px" }}>
				<svg
					style={{ cursor: "pointer" }}
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					className="button-back"
					xmlns="http://www.w3.org/2000/svg"
					onClick={() => navigate("/products")}>
					<path
						d="M9.57 5.92993L3.5 11.9999L9.57 18.0699"
						stroke="#1E1F24"
						strokeWidth="1.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M20.4999 12H3.66992"
						stroke="#1E1F24"
						strokeWidth="1.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>

				<label className="mb-0" style={{ fontSize: "20px", fontWeight: "600" }}>
					{!isAdd ? Translate[lang]?.edit : Translate[lang]?.add}{" "}
					{Translate[lang]?.product}
				</label>

				<Form.Check
					type="switch"
					id="custom-switch"
					checked={formData?.status}
					onChange={(e) =>
						setFormData({ ...formData, status: e.target.checked })
					}
				/>
			</div>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Row>
					{/* Name En */}
					<Col md={6}>
						<label className="text-label">
							{Translate[lang]?.name} ({Translate[lang]?.english})
						</label>
						<AvField
							type="text"
							placeholder={Translate[lang]?.name}
							bsSize="lg"
							name="name_en"
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							value={formData.name_en}
							onChange={(e) =>
								setFormData({
									...formData,
									name_en: e.target.value,
								})
							}
						/>
					</Col>
					{/* Name Ar */}
					<Col md={6}>
						<label className="text-label">
							{Translate[lang]?.name} ({Translate[lang]?.arabic})
						</label>
						<AvField
							type="text"
							placeholder={Translate[lang]?.name}
							bsSize="lg"
							name="name_ar"
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							value={formData.name_ar}
							onChange={(e) =>
								setFormData({
									...formData,
									name_ar: e.target.value,
								})
							}
						/>
					</Col>
					{/* Description En */}
					<Col md={6}>
						<label className="text-label">
							{Translate[lang]?.english_description}
						</label>
						<AvField
							type="textarea"
							placeholder={Translate[lang]?.english_description}
							bsSize="lg"
							name="description_en"
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							value={formData.description_en}
							onChange={(e) =>
								setFormData({
									...formData,
									description_en: e.target.value,
								})
							}
						/>
					</Col>
					{/* Description Ar */}
					<Col md={6}>
						<label className="text-label">
							{Translate[lang]?.arabic_description}
						</label>
						<AvField
							type="textarea"
							placeholder={Translate[lang]?.arabic_description}
							bsSize="lg"
							name="description_ar"
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							value={formData.description_ar}
							onChange={(e) =>
								setFormData({
									...formData,
									description_ar: e.target.value,
								})
							}
						/>
					</Col>
					{/* Category */}
					<Col md={6} className="mb-3">
						<label className="text-label">{Translate[lang]?.category}</label>
						<Select
							value={formData?.category}
							name="category"
							placeholder={Translate[lang]?.select}
							options={categoriesOptions}
							onChange={(e) => setFormData({ ...formData, category: e })}
						/>
					</Col>
					{/* Price */}
					<Col md={6}>
						<label>{Translate[lang]?.price}</label>
						<AvField
							type="number"
							placeholder={Translate[lang]?.price}
							bsSize="lg"
							name="price"
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							value={formData.price}
							onChange={(e) =>
								setFormData({
									...formData,
									price: e.target.value,
								})
							}
						/>
					</Col>
					{/* Whatsapp */}
					<Col md={6} className="mb-3">
						<label>{Translate[lang]?.whatsapp}</label>
						<PhoneInput
							country={"kw"}
							enableSearch={true}
							value={formData?.whatsapp_number}
							onChange={(e) => setFormData({ ...formData, whatsapp_number: e })}
						/>
					</Col>
					{/* Type  */}
					<Col md={6} className="mb-3">
						<label className="text-label">{Translate[lang]?.type}</label>
						<div className="mt-3 d-flex gap-16">
							<label className="mb-0 cursor-pointer d-flex gap-8 align-items-center">
								<input
									type="radio"
									name="type"
									value="type"
									checked={formData?.type === "new"}
									onChange={() =>
										setFormData({
											...formData,
											type: "new",
										})
									}
								/>{" "}
								{Translate[lang]?.new}
							</label>
							<label className="mb-0 cursor-pointer d-flex gap-8 align-items">
								<input
									type="radio"
									name="type"
									value="type"
									checked={formData?.type === "used"}
									onChange={() =>
										setFormData({
											...formData,
											type: "used",
										})
									}
								/>{" "}
								{Translate[lang]?.used}
							</label>
						</div>
					</Col>
					{/* Image */}
					<Col md={6}>
						<label className="text-label mb-0">{Translate[lang].image}</label>
						<div className="upload">
							<input
								type="file"
								name="image"
								id="image"
								onChange={(e) => fileHandler(e)}
							/>
							<p>{Translate[lang].upload_image}</p>
							{!formData?.image ? (
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M16.44 8.9C20.04 9.21 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24 7.46998 8.91"
										stroke="#0F50A6"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
									<path
										d="M12 15V3.62"
										stroke="#0F50A6"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
									<path
										d="M15.35 5.85L12 2.5L8.65002 5.85"
										stroke="#0F50A6"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							) : (
								<svg
									width="24"
									height="24"
									viewBox="0 0 16 16"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M8 1.33333C4.32667 1.33333 1.33334 4.32667 1.33334 8C1.33334 11.6733 4.32667 14.6667 8 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8C14.6667 4.32667 11.6733 1.33333 8 1.33333ZM11.1867 6.46667L7.40667 10.2467C7.31334 10.34 7.18667 10.3933 7.05334 10.3933C6.92 10.3933 6.79334 10.34 6.7 10.2467L4.81334 8.36C4.62 8.16667 4.62 7.84667 4.81334 7.65333C5.00667 7.46 5.32667 7.46 5.52 7.65333L7.05334 9.18667L10.48 5.76C10.6733 5.56667 10.9933 5.56667 11.1867 5.76C11.38 5.95333 11.38 6.26667 11.1867 6.46667Z"
										fill="#21AA37"
									/>
								</svg>
							)}
						</div>
						{!!formData?.image && (
							<img
								src={formData?.image}
								alt="product"
								width={90}
								className="mt-3"
							/>
						)}
					</Col>
				</Row>
				<Row>
					<Col md={6} className="mt-4">
						<Button
							variant="primary"
							type="submit"
							className="w-100"
							disabled={loading}>
							{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
							{Translate[lang]?.product}
						</Button>
					</Col>
				</Row>
			</AvForm>
		</div>
	);
};

export default AddProduct;
